/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function IconFactoryWrapper(Component) {
	return class IconFactory extends React.Component {
		constructor(props) {
			super(props);

			this.getIcon = this.getIcon.bind(this);

		}

		getIcon(service, iconName, background) {
			let classes = classnames(
					'dlvr-icon',
					service,
					this.props.alt,
					{
						'inactive': this.props.inactive,
						'mono': this.props.mono,
						'small': this.props.small,
						'bare': this.props.bare,
						'large': this.props.large,
						'white': this.props.white,
						'border': this.props.border,
						'square': this.props.square,
						'outline': this.props.outline,
						'round': this.props.round,
						'automation': this.props.automation
					}
				),
				iconClass = classnames({
					'fa': (iconName.match("fa-")) ? true : false,
					'ds-icon': (iconName.match("fa-")) ? false : true,
					'icon': (iconName.match('ion')) ? true: false
				}, iconName),
				backgroundIcon = null,
				backgroundIconClass = '';

			if (background && this.props.large) {
				backgroundIconClass = classnames({
					'fa': (background.icon.match("fa-")) ? true : false,
					'ds-icon': (background.icon.match("fa-")) ? false : true,
					'small': this.props.small,
					'large': this.props.large
				},
				background.icon);

				backgroundIcon = (
					<div className={"dlvr-icon-background " + service}>
						<i className={backgroundIconClass}></i>
					</div>
				);
			}

			if (this.props.loading) {
				iconClass = "fa fa-spinner fa-spin";
			}

			return (
				<div className="dlvr-icon-wrapper">
					{backgroundIcon}
					<div className={classes}>
						<i className={iconClass}></i>
					</div>
				</div>
			);
		}

		render() {
			return (
				<Component
					{...this.props}
					getIcon={this.getIcon} />
			);
		}
	};
}

class TestIcon extends React.Component {
	render() {
		return this.props.getIcon('test', 'fa-flask');
	}
};
TestIcon.displayName = "TestIcon";

class FeedIcon extends React.Component {
	render() {
		return this.props.getIcon('feed', 'fa-rss');
	}
};
FeedIcon.displayName = "FeedIcon";

class InstagramIcon extends React.Component {
	render() {
		return this.props.getIcon('instagram', 'fa-instagram');
	}
};
InstagramIcon.displayName = "InstagramIcon";

class InstagramBusinessIcon extends React.Component {
	render() {
		return this.props.getIcon('instagram-business', 'fa-instagram');
	}
};
InstagramBusinessIcon.displayName = "InstagramBusinessIcon";

class PinterestIcon extends React.Component {
	render() {
		return this.props.getIcon('pinterest', this.props.outline ? 'fa-pinterest-p' : this.props.square ? 'fa-pinterest-square' : 'fa-pinterest');
	}
};
PinterestIcon.displayName = "PinterestIcon";

class EmailIcon extends React.Component {
	render() {
		return this.props.getIcon('email', 'fa-envelope-o');
	}
};
EmailIcon.displayName = "EmailIcon";

class TwitterIcon extends React.Component {
	render() {
		return this.props.getIcon('twitter', this.props.square ? 'fa-twitter-square' : 'fa-twitter');
	}
};
TwitterIcon.displayName = "TwitterIcon";

class RetweetIcon extends React.Component {
	render() {
		return this.props.getIcon('x', this.props.square ? 'icon-retweet-square' : 'icon-retweet');
	}
};
RetweetIcon.displayName = "RetweetIcon";

class FacebookIcon extends React.Component {
	render() {
		return this.props.getIcon('facebook', 'fa-facebook');
	}
};
FacebookIcon.displayName = "FacebookIcon";

class FacebookGroupsIcon extends React.Component {
	render() {
		return this.props.getIcon('facebookgroups', 'icon-facebook-groups');
	}
};
FacebookGroupsIcon.displayName = "FacebookGroupsIcon";

class TumblrIcon extends React.Component {
	render() {
		return this.props.getIcon('tumblr', 'fa-tumblr');
	}
};
TumblrIcon.displayName = "TumblrIcon";

class LinkedInIcon extends React.Component {
	render() {
		return this.props.getIcon('linkedin', 'fa-linkedin');
	}
};
LinkedInIcon.displayName = "LinkedInIcon";

class TopFeedIcon extends React.Component {

	render() {
		return this.props.getIcon('topfeed', 'fa-rss');
	}
};
TopFeedIcon.displayName = "TopFeedIcon";

class GooglePlusIcon extends React.Component {

	render() {
		return this.props.getIcon('googleplus', 'fa-google-plus');
	}
};
GooglePlusIcon.displayName = "GooglePlusIcon";

class GoogleIcon extends React.Component {

	render() {
		return this.props.getIcon('google', 'fa-google');
	}
};
GoogleIcon.displayName = "GoogleIcon";

class StockTwitsIcon extends React.Component {
	render() {
		return this.props.getIcon('stocktwits', 'icon-stocktwits');
	}
};
StockTwitsIcon.displayName = "StockTwitsIcon";

class DlvrIcon extends React.Component {
	render() {
		return this.props.getIcon('dlvr', 'icon-dlvr');
	}
};
DlvrIcon.displayName = "DlvrIcon";

class BitlyIcon extends React.Component {
	render() {
		return this.props.getIcon('bitly', 'icon-bitly');
	}
};
BitlyIcon.displayName = "BitlyIcon";

class CustomShortenerIcon extends React.Component {
	render() {
		return this.props.getIcon('custom-shortener', 'fa-link');
	}
};
CustomShortenerIcon.displayName = "CustomShortenerIcon";

class CustomDomainIcon extends React.Component {
	render() {
		return this.props.getIcon('custom-domain', 'fa-globe');
	}
};
CustomDomainIcon.displayName = "CustomDomainIcon";

class NoShortenerIcon extends React.Component {
	render() {
		return this.props.getIcon('no-shortener', 'fa-minus-circle');
	}
};
NoShortenerIcon.displayName = "NoShortenerIcon";

class FeedQueue extends React.Component {
	render() {
		return this.props.getIcon('queue feed', 'fa-list-ul');
	}
};
FeedQueue.displayName = "FeedQueue";

class TwitterQueue extends React.Component {
	render() {
		return this.props.getIcon('queue twitter', 'fa-list-ul');
	}
};
TwitterQueue.displayName = "TwitterQueue";

class InstagramQueue extends React.Component {
	render() {
		return this.props.getIcon('queue instagram', 'fa-list-ul');
	}
};
InstagramQueue.displayName = "InstagramQueue";

class PinterestQueue extends React.Component {
	render() {
		return this.props.getIcon('queue pinterest', 'fa-list-ul');
	}
};
PinterestQueue.displayName = "PinterestQueue";

class WordpressIcon extends React.Component {
	render() {
		return this.props.getIcon('wordpress', 'fa-wordpress');
	}
};
WordpressIcon.displayName = "WordpressIcon";

class GenericUserIcon extends React.Component {
	render() {
		return this.props.getIcon('user', 'fa-user');
	}
};
GenericUserIcon.displayName = "GenericUserIcon";

class SocialsIcon extends React.Component {
	render() {
		return this.props.getIcon('socials', 'icon-socials-icon');
	}
};
SocialsIcon.displayName = "SocialsIcon";

class SlackIcon extends React.Component {
	render() {
		return this.props.getIcon('slack', 'icon-slack');
	}
};
SlackIcon.displayName = "SlackIcon";

class DiscordIcon extends React.Component {
	render() {
		return this.props.getIcon('discord', 'icon-discord');
	}
};
DiscordIcon.displayName = "DiscordIcon";

class GMBIcon extends React.Component {
	render() {
		return this.props.getIcon('gmb', 'icon-gmb');
	}
};
GMBIcon.displayName = "GMBIcon";

class ShopifyIcon extends React.Component {
	render() {
		return this.props.getIcon('shopify', 'icon-shopify');
	}
}
ShopifyIcon.displayName = "ShopifyIcon";

class SubstackIcon extends React.Component {
	render() {
		return this.props.getIcon('substack', 'icon-substack');
	}
}
SubstackIcon.displayName = "SubstackIcon";

class YouTubeIcon extends React.Component {
	render() {
		return this.props.getIcon('youtube', 'fa-youtube-play');
	}
}
YouTubeIcon.displayName = "YouTubeIcon";

class VimeoIcon extends React.Component {
	render() {
		return this.props.getIcon('vimeo', 'ion-social-vimeo');
	}
}
VimeoIcon.displayName = "VimeoIcon";

class EtsyIcon extends React.Component {
	render() {
		return this.props.getIcon('etsy', 'fa-etsy');
	}
}
EtsyIcon.displayName = "EtsyIcon";

class EbayIcon extends React.Component {
	render() {
		return this.props.getIcon('ebay', 'icon-ebay');
	}
}
EbayIcon.displayName = "EbayIcon";

class SearchIcon extends React.Component {
	render() {
		return this.props.getIcon('search', 'ion-ios-search-strong');
	}
}
SearchIcon.displayName = "SearchIcon";

class BloggerIcon extends React.Component {
	render() {
		return this.props.getIcon('blogger', 'icon-blogger');
	}
}
BloggerIcon.displayName = "BloggerIcon";

class TikTokIcon extends React.Component {
	render() {
		return this.props.getIcon('tiktok', 'icon-tiktok');
	}
}
TikTokIcon.displayName = "TikTokIcon";

class RedditIcon extends React.Component {
	render() {
		return this.props.getIcon('reddit', 'fa-reddit-alien');
	}
}
RedditIcon.displayName = "RedditIcon";

class WordpressOutputIcon extends React.Component {
	render() {
		return this.props.getIcon('wordpressOutput', 'fa-wordpress');
	}
}
WordpressOutputIcon.displayName = "WordpressOutputIcon";

class AlertIcon extends React.Component {
	render() {
		return this.props.getIcon('alert', 'fa-exclamation');
	}
}
AlertIcon.displayName = "AlertIcon";

class MastodonIcon extends React.Component {
	render() {
		return this.props.getIcon('mastodon', 'icon-mastodon');
	}
}
MastodonIcon.displayName = "MastodonIcon";

class NextdoorIcon extends React.Component {
	render() {
		return this.props.getIcon('nextdoor', 'icon-nextdoor');
	}
}
NextdoorIcon.displayName = "NextdoorIcon";

class XIcon extends React.Component {
	render() {
		return this.props.getIcon('x', 'icon-x');
	}
}
XIcon.displayName = "XIcon";

class BlueskyIcon extends React.Component {
	render() {
		return this.props.getIcon('bluesky', 'icon-bluesky');
	}
}
BlueskyIcon.displayName = "BlueskyIcon";

class ThreadsIcon extends React.Component {
	render() {
		return this.props.getIcon('threads', 'icon-threads');
	}
}
ThreadsIcon.displayName = "ThreadsIcon";

class SnapchatIcon extends React.Component {
	render() {
		return this.props.getIcon('snapchat', 'fa-snapchat-ghost');
	}
}
SnapchatIcon.displayName = "SnapchatIcon";

const TestWrapped = IconFactoryWrapper(TestIcon);
const FeedWrapped = IconFactoryWrapper(FeedIcon);
const InstagramWrapped = IconFactoryWrapper(InstagramIcon);
const InstagramBusinessWrapped = IconFactoryWrapper(InstagramBusinessIcon);
const PinterestWrapped = IconFactoryWrapper(PinterestIcon);
const EmailWrapped = IconFactoryWrapper(EmailIcon);
const TwitterWrapped = IconFactoryWrapper(TwitterIcon);
const RetweetWrapped = IconFactoryWrapper(RetweetIcon);
const FacebookWrapped = IconFactoryWrapper(FacebookIcon);
const FacebookGroupsWrapped = IconFactoryWrapper(FacebookGroupsIcon);
const TumblrWrapped = IconFactoryWrapper(TumblrIcon);
const LinkedInWrapped = IconFactoryWrapper(LinkedInIcon);
const GooglePlusWrapped = IconFactoryWrapper(GooglePlusIcon);
const GoogleWrapped = IconFactoryWrapper(GoogleIcon);
const StockTwitsWrapped = IconFactoryWrapper(StockTwitsIcon);
const DlvrWrapped = IconFactoryWrapper(DlvrIcon);
const BitlyWrapped = IconFactoryWrapper(BitlyIcon);
const CustomShortenerWrapped = IconFactoryWrapper(CustomShortenerIcon);
const CustomDomainWrapped = IconFactoryWrapper(CustomDomainIcon);
const NoShortenerWrapped = IconFactoryWrapper(NoShortenerIcon);
const FeedQueueWrapped = IconFactoryWrapper(FeedQueue);
const TwitterQueueWrapped = IconFactoryWrapper(TwitterQueue);
const InstagramQueueWrapped = IconFactoryWrapper(InstagramQueue) ;
const PinterestQueueWrapped = IconFactoryWrapper(PinterestQueue);
const WordpressWrapped = IconFactoryWrapper(WordpressIcon);
const GenericWrapped = IconFactoryWrapper(GenericUserIcon);
const SocialsWrapped = IconFactoryWrapper(SocialsIcon);
const SlackWrapped = IconFactoryWrapper(SlackIcon);
const DiscordWrapped = IconFactoryWrapper(DiscordIcon);
const GMBWrapped = IconFactoryWrapper(GMBIcon);
const ShopifyWrapped = IconFactoryWrapper(ShopifyIcon);
const SubstackWrapped = IconFactoryWrapper(SubstackIcon);
const YouTubeWrapped = IconFactoryWrapper(YouTubeIcon);
const VimeoWrapped = IconFactoryWrapper(VimeoIcon);
const EtsyWrapped = IconFactoryWrapper(EtsyIcon);
const EbayWrapped = IconFactoryWrapper(EbayIcon);
const SearchWrapped = IconFactoryWrapper(SearchIcon);
const BloggerWrapped = IconFactoryWrapper(BloggerIcon);
const TikTokWrapped = IconFactoryWrapper(TikTokIcon);
const RedditWrapped = IconFactoryWrapper(RedditIcon);
const WordpressOutputWrapped = IconFactoryWrapper(WordpressOutputIcon);
const AlertWrapped = IconFactoryWrapper(AlertIcon);
const MastodonWrapped = IconFactoryWrapper(MastodonIcon);
const NextdoorWrapped = IconFactoryWrapper(NextdoorIcon);
const XWrapped = IconFactoryWrapper(XIcon);
const BlueskyWrapped = IconFactoryWrapper(BlueskyIcon);
const ThreadsWrapped = IconFactoryWrapper(ThreadsIcon);
const SnapchatWrapped = IconFactoryWrapper(SnapchatIcon);

export {
	TestWrapped as test,
	FeedWrapped as feed,
	InstagramWrapped as instagram,
	InstagramBusinessWrapped as instagrambusiness,
	PinterestWrapped as pinterest,
	EmailWrapped as email,
	TwitterWrapped as twitter,
	RetweetWrapped as retweet,
	FacebookWrapped as facebook,
	FacebookGroupsWrapped as facebookgroups,
	TumblrWrapped as tumblr,
	LinkedInWrapped as linkedin,
	GooglePlusWrapped as googleplus,
	GoogleWrapped as google,
	StockTwitsWrapped as stocktwits,
	DlvrWrapped as dlvr,
	BitlyWrapped as bitly,
	CustomShortenerWrapped as customShortener,
	CustomDomainWrapped as customDomain,
	NoShortenerWrapped as noShortener,
	FeedQueueWrapped as feedQueue,
	TwitterQueueWrapped as twitterQueue,
	InstagramQueueWrapped as instagramQueue,
	PinterestQueueWrapped as pinterestQueue,
	WordpressWrapped as wordpress,
	GenericWrapped as generic,
	SocialsWrapped as socials,
	SlackWrapped as slack,
	DiscordWrapped as discord,
	GMBWrapped as gmb,
	ShopifyWrapped as shopify,
	SubstackWrapped as substack,
	YouTubeWrapped as youtube,
	VimeoWrapped as vimeo,
	EtsyWrapped as etsy,
	EbayWrapped as ebay,
    SearchWrapped as search,
    BloggerWrapped as blogger,
    TikTokWrapped as tiktok,
    RedditWrapped as reddit,
    WordpressOutputWrapped as wordpressOutput,
	AlertWrapped as alert,
	MastodonWrapped as mastodon,
	NextdoorWrapped as nextdoor,
	XWrapped as x,
	BlueskyWrapped as bluesky,
	ThreadsWrapped as threads,
	SnapchatWrapped as snapchat
};
